export const ALPHAMD_DEFAULT_REP = Object.freeze({
  isAlphaMdDefault: true,
  profile: "/Images/alphamd-half-logo.png",
  companyName: "Alpha.MD",
  repDetails: {
    firstName: "Alpha.MD",
    lastName: "Representative",
  },
  repProducts: [],
  addressDetails: {
    state: "Nationwide",
    country: "United States",
  },
});

export const withAlphaMdDefaultRep = (reps) =>
  Array.isArray(reps) && reps.length > 0 ? reps : [ALPHAMD_DEFAULT_REP];
